import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import React, { forwardRef, useEffect, useMemo } from 'react';
import styled from 'styled-components';
import { Spin } from 'antd';
import { useSelectLibrary } from './select-library.hook';
import { getFileType, FileType, formatFileSize } from '../../utils/file-type.utils';
import { FileOutlined, PictureOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { useDeleteConfirmation } from '../../hooks/use-delete-confirmation.hook';
import { SecondaryButton } from '@lib/common';
import { isFileExtensionAllowed, isFileSizeWithinLimit } from '../../config/ai-chat-file-constraints';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Container = styled.div.withConfig({
  displayName: "select-librarycontainer__Container",
  componentId: "sc-1b188uf-0"
})(["display:flex;flex-direction:column;height:100%;width:100%;padding:0;"]);
var Header = styled.div.withConfig({
  displayName: "select-librarycontainer__Header",
  componentId: "sc-1b188uf-1"
})(["display:flex;justify-content:space-between;align-items:center;margin-bottom:16px;padding:0 4px;"]);
var Title = styled.div.withConfig({
  displayName: "select-librarycontainer__Title",
  componentId: "sc-1b188uf-2"
})(["font-size:14px;font-weight:600;color:#1a2140;text-transform:uppercase;letter-spacing:0.5px;"]);
var SelectionCounter = styled.div.withConfig({
  displayName: "select-librarycontainer__SelectionCounter",
  componentId: "sc-1b188uf-3"
})(["font-size:14px;color:#64748b;font-weight:500;"]);
var ErrorMessage = styled.div.withConfig({
  displayName: "select-librarycontainer__ErrorMessage",
  componentId: "sc-1b188uf-4"
})(["color:#ff4d4f;font-size:12px;margin-top:8px;text-align:center;"]);
var LoadingSpinner = styled.div.withConfig({
  displayName: "select-librarycontainer__LoadingSpinner",
  componentId: "sc-1b188uf-5"
})(["display:flex;align-items:center;justify-content:center;padding:40px 20px;color:#5a6acf;"]);
var FileList = styled.div.withConfig({
  displayName: "select-librarycontainer__FileList",
  componentId: "sc-1b188uf-6"
})(["display:flex;flex-direction:column;gap:12px;width:100%;max-height:400px;overflow-y:auto;padding-right:8px;position:relative;&::-webkit-scrollbar{width:6px;}&::-webkit-scrollbar-track{background:#f1f5f9;border-radius:3px;}&::-webkit-scrollbar-thumb{background:#cbd5e1;border-radius:3px;&:hover{background:#94a3b8;}}"]);
var FileItem = styled.div.withConfig({
  displayName: "select-librarycontainer__FileItem",
  componentId: "sc-1b188uf-7"
})(["display:flex;align-items:center;padding:16px;background:white;border:1px solid #f1f5f9;border-radius:12px;cursor:", ";box-shadow:0 1px 3px rgba(0,0,0,0.1),0 1px 2px rgba(0,0,0,0.06);transition:all 0.2s ease;opacity:", ";", ""], function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.disabled ? 0.6 : 1;
}, function (props) {
  return !props.disabled && "\n    &:hover {\n      background: #f8fafc;\n      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06);\n      transform: translateY(-1px);\n    }\n  ";
});
var FileIcon = styled.div.withConfig({
  displayName: "select-librarycontainer__FileIcon",
  componentId: "sc-1b188uf-8"
})(["width:40px;height:40px;display:flex;align-items:center;justify-content:center;border-radius:8px;margin-right:16px;font-size:18px;", ""], function (_ref) {
  var fileType = _ref.fileType;

  switch (fileType) {
    case FileType.PDF:
      return "\n          background: #fef2f2;\n          color: #dc2626;\n        ";

    case FileType.IMAGE:
      return "\n          background: #f0f9ff;\n          color: #0284c7;\n        ";

    case FileType.DOCUMENT:
      return "\n          background: #eff6ff;\n          color: #2563eb;\n        ";

    default:
      return "\n          background: #f8fafc;\n          color: #64748b;\n        ";
  }
});
var Checkbox = styled.input.withConfig({
  displayName: "select-librarycontainer__Checkbox",
  componentId: "sc-1b188uf-9"
})(["margin-right:12px;width:16px;height:16px;cursor:pointer;"]);
var FileInfo = styled.div.withConfig({
  displayName: "select-librarycontainer__FileInfo",
  componentId: "sc-1b188uf-10"
})(["flex:1;min-width:0;"]);
var FileName = styled.div.withConfig({
  displayName: "select-librarycontainer__FileName",
  componentId: "sc-1b188uf-11"
})(["font-weight:500;color:#1a2140;font-size:14px;margin-bottom:4px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);
var FileMeta = styled.div.withConfig({
  displayName: "select-librarycontainer__FileMeta",
  componentId: "sc-1b188uf-12"
})(["font-size:12px;color:#64748b;font-weight:400;"]);
var DeleteButton = styled.button.withConfig({
  displayName: "select-librarycontainer__DeleteButton",
  componentId: "sc-1b188uf-13"
})(["padding:6px;background:transparent;color:#94a3b8;border:none;border-radius:6px;cursor:", ";display:flex;align-items:center;justify-content:center;font-size:14px;transition:all 0.2s ease;opacity:", ";", ":hover &{opacity:", ";}", ""], function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.disabled ? 0.5 : 0;
}, FileItem, function (props) {
  return props.disabled ? 0.5 : 1;
}, function (props) {
  return !props.disabled && "\n    &:hover {\n      background: #fef2f2;\n      color: #dc2626;\n    }\n  ";
});
var PlaceholderText = styled.div.withConfig({
  displayName: "select-librarycontainer__PlaceholderText",
  componentId: "sc-1b188uf-14"
})(["font-size:15px;text-align:center;color:#64748b;padding:40px 20px;"]);
var Tooltip = styled.div.withConfig({
  displayName: "select-librarycontainer__Tooltip",
  componentId: "sc-1b188uf-15"
})(["position:absolute;top:-40px;left:50%;transform:translateX(-50%);background:#1f2937;color:white;padding:8px 12px;border-radius:6px;font-size:12px;white-space:nowrap;z-index:1000;opacity:", ";visibility:", ";transition:all 0.2s ease;pointer-events:none;&::after{content:'';position:absolute;top:100%;left:50%;transform:translateX(-50%);border:4px solid transparent;border-top-color:#1f2937;}"], function (props) {
  return props.show ? 1 : 0;
}, function (props) {
  return props.show ? 'visible' : 'hidden';
});
var NoMoreFilesIndicator = styled.div.withConfig({
  displayName: "select-librarycontainer__NoMoreFilesIndicator",
  componentId: "sc-1b188uf-16"
})(["display:flex;align-items:center;justify-content:center;padding:16px 20px;color:#94a3b8;font-size:12px;font-style:italic;border-top:1px solid #f1f5f9;margin-top:8px;"]);
var LoadMoreIndicator = styled.div.withConfig({
  displayName: "select-librarycontainer__LoadMoreIndicator",
  componentId: "sc-1b188uf-17"
})(["display:flex;align-items:center;justify-content:center;padding:24px 20px;min-height:72px;color:#64748b;font-size:14px;font-weight:500;transition:all 0.3s ease-in-out;opacity:1;transform:translateY(0);&.loading-hidden{opacity:0;transform:translateY(-10px);pointer-events:none;}"]);
var CheckboxWrapper = styled.div.withConfig({
  displayName: "select-librarycontainer__CheckboxWrapper",
  componentId: "sc-1b188uf-18"
})(["position:relative;display:inline-block;", ""], function (props) {
  return props.disabled && "\n    &:hover ".concat(Tooltip, " {\n      opacity: 1;\n      visibility: visible;\n    }\n  ");
});

// Helper function to get file icon based on file type
var getFileIcon = function getFileIcon(fileType) {
  switch (fileType) {
    case FileType.PDF:
      return /*#__PURE__*/_jsx(ExclamationCircleOutlined, {});

    case FileType.IMAGE:
      return /*#__PURE__*/_jsx(PictureOutlined, {});

    case FileType.DOCUMENT:
      return /*#__PURE__*/_jsx(FileOutlined, {});

    default:
      return /*#__PURE__*/_jsx(FileOutlined, {});
  }
};

export var SelectLibraryContainer = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var disabled = _ref2.disabled,
      fileSelector = _ref2.fileSelector,
      maxFileUpload = _ref2.maxFileUpload,
      allowedFileTypes = _ref2.allowedFileTypes,
      fileSizeLimitMb = _ref2.fileSizeLimitMb,
      totalSizeLimitMb = _ref2.totalSizeLimitMb,
      onSelectionChange = _ref2.onSelectionChange,
      _ref2$hideSelectionCo = _ref2.hideSelectionCounter,
      hideSelectionCounter = _ref2$hideSelectionCo === void 0 ? false : _ref2$hideSelectionCo;
  var libraryHook = useSelectLibrary();

  var _useDeleteConfirmatio = useDeleteConfirmation({
    itemType: 'library',
    itemName: 'file'
  }),
      confirmDelete = _useDeleteConfirmatio.confirmDelete;

  var eligibleFiles = useMemo(function () {
    return libraryHook.files.filter(function (file) {
      var _file$size;

      var fileName = file.fileName || '';
      return isFileExtensionAllowed(fileName, allowedFileTypes !== null && allowedFileTypes !== void 0 ? allowedFileTypes : []) && isFileSizeWithinLimit((_file$size = file.size) === null || _file$size === void 0 ? void 0 : _file$size.value, fileSizeLimitMb !== null && fileSizeLimitMb !== void 0 ? fileSizeLimitMb : 0);
    });
  }, [allowedFileTypes, fileSizeLimitMb, libraryHook.files]);
  var totalSelectedCount = libraryHook.selectedFiles.filter(function (id) {
    return eligibleFiles.some(function (file) {
      return file.id.toString() === id;
    });
  }).length;
  var selectedTotalSize = eligibleFiles.filter(function (file) {
    return libraryHook.selectedFiles.includes(file.id.toString());
  }).reduce(function (total, file) {
    var _file$size$value, _file$size2;

    return total + ((_file$size$value = (_file$size2 = file.size) === null || _file$size2 === void 0 ? void 0 : _file$size2.value) !== null && _file$size$value !== void 0 ? _file$size$value : 0);
  }, 0); // Call onSelectionChange when selection changes

  useEffect(function () {
    if (onSelectionChange) {
      // Get actual FileV2 objects from libraryHook.files based on selected IDs
      var selectedFiles = eligibleFiles.filter(function (file) {
        return libraryHook.selectedFiles.includes(file.id.toString());
      });
      onSelectionChange(selectedFiles);
    }
  }, [libraryHook.selectedFiles, eligibleFiles, onSelectionChange]); // Render file list items directly without memo to ensure proper re-rendering on selection changes

  var renderFileItems = function renderFileItems() {
    return eligibleFiles.map(function (file) {
      var _file$size3;

      var fileType = getFileType(file.fileName || '');
      var fileSize = file.size ? formatFileSize(file.size.value) : 'Unknown size';
      var fileId = file.id.toString();
      var isDisabled = isFileDisabled(fileId, (_file$size3 = file.size) === null || _file$size3 === void 0 ? void 0 : _file$size3.value);
      return /*#__PURE__*/_jsxs(FileItem, {
        disabled: isDisabled,
        onClick: function onClick() {
          return !isDisabled && handleFileSelect(fileId);
        },
        children: [/*#__PURE__*/_jsxs(CheckboxWrapper, {
          disabled: isDisabled,
          children: [/*#__PURE__*/_jsx(Checkbox, {
            type: "checkbox",
            checked: libraryHook.selectedFiles.includes(fileId),
            onChange: function onChange(e) {
              e.stopPropagation();
              handleFileSelect(fileId);
            },
            disabled: isDisabled,
            onClick: function onClick(e) {
              return e.stopPropagation();
            }
          }), isDisabled && /*#__PURE__*/_jsx(Tooltip, {
            show: false,
            children: "Maximum file limit reached. Deselect a file to select this one."
          })]
        }), /*#__PURE__*/_jsx(FileIcon, {
          fileType: fileType,
          children: getFileIcon(fileType)
        }), /*#__PURE__*/_jsxs(FileInfo, {
          children: [/*#__PURE__*/_jsx(FileName, {
            children: file.fileName
          }), /*#__PURE__*/_jsx(FileMeta, {
            children: fileSize
          })]
        }), /*#__PURE__*/_jsx(DeleteButton, {
          onClick: function onClick() {
            return handleDeleteFile(fileId, file.fileName);
          },
          disabled: isDisabled,
          children: "\xD7"
        })]
      }, fileId);
    });
  };

  var handleFileSelect = function handleFileSelect(fileId) {
    var _file$size4;

    var file = eligibleFiles.find(function (item) {
      return item.id.toString() === fileId;
    });

    if (isFileDisabled(fileId, file === null || file === void 0 ? void 0 : (_file$size4 = file.size) === null || _file$size4 === void 0 ? void 0 : _file$size4.value)) {
      return;
    }

    libraryHook.toggleFileSelection(fileId);
  };

  var handleDeleteFile = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(fileId, fileName) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              confirmDelete(function () {
                libraryHook.deleteFile(fileId);
              });

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleDeleteFile(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }(); // Check if a specific file should be disabled


  var isFileDisabled = function isFileDisabled(fileId, fileSize) {
    if (disabled) {
      return true;
    }

    var exceedsTotalSize = Boolean(totalSizeLimitMb && totalSizeLimitMb > 0) && !libraryHook.selectedFiles.includes(fileId) && selectedTotalSize + (fileSize !== null && fileSize !== void 0 ? fileSize : 0) > totalSizeLimitMb * 1024 * 1024;
    return exceedsTotalSize || Boolean(maxFileUpload) && totalSelectedCount >= maxFileUpload && !libraryHook.selectedFiles.includes(fileId);
  };

  return /*#__PURE__*/_jsx(Container, {
    children: libraryHook.isLoading ? /*#__PURE__*/_jsxs(LoadMoreIndicator, {
      children: [/*#__PURE__*/_jsx(Spin, {
        size: "small",
        style: {
          marginRight: '8px'
        }
      }), "Loading files..."]
    }) : eligibleFiles.length === 0 && !libraryHook.isLoadingMore ? /*#__PURE__*/_jsxs(PlaceholderText, {
      children: [/*#__PURE__*/_jsx("div", {
        children: "No files found in your library."
      }), /*#__PURE__*/_jsx("div", {
        children: "Upload some files first to see them here."
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [eligibleFiles.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(Header, {
          children: [/*#__PURE__*/_jsx(Title, {
            children: "RECENT FILES IN LIBRARY"
          }), !hideSelectionCounter && /*#__PURE__*/_jsxs(SelectionCounter, {
            children: [totalSelectedCount, "/", maxFileUpload !== null && maxFileUpload !== void 0 ? maxFileUpload : '∞', " files selected"]
          })]
        }), /*#__PURE__*/_jsxs(FileList, {
          children: [renderFileItems(), libraryHook.isLoadingMore && /*#__PURE__*/_jsxs(LoadMoreIndicator, {
            children: [/*#__PURE__*/_jsx(Spin, {
              size: "small",
              style: {
                marginRight: '8px'
              }
            }), "Loading more files..."]
          })]
        })]
      }), /*#__PURE__*/_jsx("div", {
        style: {
          padding: '20px 0',
          textAlign: 'center'
        },
        children: libraryHook.hasNextPage ? /*#__PURE__*/_jsx(SecondaryButton, {
          onClick: libraryHook.loadMoreFiles,
          loading: libraryHook.isLoadingMore,
          disabled: libraryHook.isLoadingMore,
          children: libraryHook.isLoadingMore ? 'Loading...' : 'Load More'
        }) : libraryHook.files.length > 0 ? /*#__PURE__*/_jsx(NoMoreFilesIndicator, {
          children: "No more records to load"
        }) : null
      }), libraryHook.error && /*#__PURE__*/_jsx(ErrorMessage, {
        children: libraryHook.error
      })]
    })
  });
});
SelectLibraryContainer.displayName = 'SelectLibraryContainer';